import { Field } from '..';
import { Report } from './report';
import { ReportDefinitionHeader } from './report-definition-header';
import { ReportFormattingData } from './report-formatting-data';

export class ReportsServiceModel {
    report: Report;
    reportLoading: boolean;
    reportsMap: Map<string, Report>;
    reportDefinitionsHeaders: ReportDefinitionHeader[] = [];
    reportFormatData: ReportFormattingData;
    reportFormatDataMap: Map<string, ReportFormattingData>;
    currentProjectFields: Field[] = [];
}
